module.exports = __webpack_public_path__ + "static/media/lock.14ce5047.svg";